module.exports = __webpack_public_path__ + "static/media/strengthstore1.660ae00c.jpg";